export default __webpack_public_path__ + "static/media/userIcon.aabca51f.png";